import { useEffect } from "react";

const DEFAULT_AUTO_CLEAR_DELAY_MS = 2000;

// 피드백 문구(message/error)를 일정 시간 뒤 자동으로 비운다.
function useAutoClearMessage(value, clearFn, delayMs = DEFAULT_AUTO_CLEAR_DELAY_MS) {
  useEffect(() => {
    if (!value || typeof clearFn !== "function") {
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      clearFn("");
    }, delayMs);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [value, clearFn, delayMs]);
}

export default useAutoClearMessage;

